import * as config from './config';

export { config };

export default config;
